export const logRocketApiKey: string = 'xjnijt/januszcasinocom';
